import styled from "styled-components";

export const Cont = styled.div`
  display: flex;
`;
export const ContLeft = styled.div`
  width: 14.8rem;
  height: 12.2rem;
  // border-radius: 7.7rem;
  border: solid 0.1rem #e5edf6;
  box-shadow: 0 0.2rem 0.6rem 0 rgba(203, 203, 203, 0.5);
  flex-shrink: 0;
  margin-right: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .engineType {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.4rem;
    height: 2.1rem;
    border-radius: 0.2rem 0.2rem 0.2rem 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: #efefef;
    position: absolute;
    left: -0.8rem;
    top: 1rem;
    ::after {
      content: "";
      width: 0;
      height: 0;
      border-left: 0.5rem solid transparent;
      border-right: 0.5rem solid transparent;
      position: absolute;
      left: 0.1rem;
      bottom: -0.4rem;
      transform: rotate(45deg);
    }
  }
  .engineType.bc {
    background-color: ${(p) => (p.bc ? p.bc : "#1b9564")}
  }
  }
`;

export const CabImg = styled.img.attrs((props) => ({
  src: props.src || "https://gos3.ibcdn.com/dwebgosafesafep-1588933414.png",
}))`
  width: 10.2rem;
  height: 5.6rem;
`;

export const Content = styled.div`
  flex: 1;
  .cabDtlhHeader {
    display: flex;
    align-items: center;
    margin-bottom: 0.6rem;
    h4 {
      font-family: 'Rubik';
      font-size: ${(p) => (p.theme ? p.theme.font.fontSizes.font22 : "2.2rem")};
      color: ${(p) => (p.theme ? p.theme.colors.black.base : "#141823")};
      font-weight: 600;
    }
  }
  .tagText {
    margin-left: 1rem;
    cursor: pointer;
    position: relative;
    > span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.6rem;
      height: 2rem;
      border-radius: 0.8rem;
      background-color: #eef4fd;
      font-size: ${(p) => (p.theme ? p.theme.font.fontSizes.font12 : "1.2rem")};
      color: ${(p) => (p.theme ? p.theme.colors.goBrand.blue : "#2276e3")};
    }
  }
  .cabType {
    height: 2rem;
    border-radius: 0.2rem;
    border: solid 0.1rem #e5edf6;
    display: inline-flex;
    align-items: center;
    padding: 0 0.4rem;
    font-size: ${(p) => (p.theme ? p.theme.font.fontSizes.font12 : "1.2rem")};
    color: ${(p) => (p.theme ? p.theme.colors.grey.grey75 : "#4f525a")};
    margin-right: 1rem;
  }
  .cabDtlFooter {
    display: flex;
    align-items: center;
  }
  .cabOfferings__list {
    display: flex;
    > li {
      display: flex;
      align-items: center;
      margin-right: 1.5rem;
      font-size: ${(p) => (p.theme ? p.theme.font.fontSizes.font12 : "1.2rem")};
      color: ${(p) => (p.theme ? p.theme.colors.grey.grey75 : "#4f525a")};
    }
  }
  .safetyMeasure {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
  }
  .goSafeTag {
    height: 2.6rem;
    border-radius: 0.4rem;
    background-color: #e9f6ea;
    padding: 0 0.6rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 1rem;
  }
  .safetyMeasureList {
    display: flex;
    font-size: 1.2rem;
    color: #141823;
    > li {
      display: flex;
      align-items: center;
      background-color: #e9f6ea;
      padding: 0 1rem;
      margin: 0 1rem 0 0;
      border-radius: 0.4rem;
      height: 2.6rem;
      flex-shrink: 0;
      font-size: 1.4rem;
      pointer: cursor;
    }
  }
  .viewDtl {
    display: inline-flex;
    align-items: center;
    font-size: 1.4rem;
    color: #166bd3;
    ::after {
      content: "";
      border: solid #2276e3;
      border-width: 0 0.2rem 0.2rem 0;
      display: inline-block;
      padding: 0.3rem;
      transform: rotate(45deg);
      margin-left: 1rem;
      margin-top: -0.2rem;
    }
  }
  .toggleUp {
    ::after {
      transform: rotate(-135deg);
      transtion: transform 0.3s;
      margin-top: 0.4rem;
    }
  }
`;
export const ContRight = styled.div`
  flex-shrink: 0;
  width: 13rem;
  margin-left: 1rem;
  text-align: right;
  .fcText {
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #2bac36;
  }
`;

export const Details = styled.div`
  margin-top: 1rem;
`;

export const ToolTip = styled.div`
  position: absolute;
`;

export const FuelPersuasion = styled.div`
  font-size: 12px;
  color: #141823;
  background-color: #fef8e5;
  padding: 0.8rem;
  margin-top: 0.8rem;
`;
